var _require = require('./formatters'),
  cpfFormatter = _require.cpfFormatter,
  cnpjFormatter = _require.cnpjFormatter,
  mexicanDocumentIdFormatter = _require.mexicanDocumentIdFormatter;
module.exports = {
  cpfFormatter: cpfFormatter,
  cnpjFormatter: cnpjFormatter,
  mexicanDocumentIdFormatter: mexicanDocumentIdFormatter
};